var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('role-promission',{attrs:{"subTitle":"角色权限编辑","roleApi":_vm.setmeal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }